import React from "react"
import { Button, Dropdown, Typography } from "@mimber/ui-web"
import { MoreOutlined, DeleteOutlined, EditOutlined } from "@mimber/ui-web"
import { usePermissionedMenuItems } from "@/core/hooks/usePermissionedMenuItems"
import { useRemoveGroupMemberModal } from "@/components/modals"
import { Resource, Action } from "@mimber/schema"
import type { PermissionedMenuItem } from "@/core/hooks/usePermissionedMenuItems/usePermissionedMenuItems.types"
import type { GroupMemberActionsDropdownProps } from "./GroupMemberActionsDropdown.types"

const { Text } = Typography

export const GroupMemberActionsDropdown: React.FunctionComponent<
  GroupMemberActionsDropdownProps
> = ({
  member,
  groupUuid,
  onEditMember,
  onActionComplete,
  size = "small",
  type = "text",
  iconOnly = true,
}) => {
  const { contextHolder, showRemoveGroupMemberModal } =
    useRemoveGroupMemberModal()

  const handleEdit = () => {
    onEditMember?.(member)
  }

  const handleRemove = () => {
    showRemoveGroupMemberModal({
      member,
      groupUuid,
      onConfirm: () => {
        onActionComplete?.()
      },
    })
  }

  const getActionMenuItems = (): PermissionedMenuItem[] => {
    return [
      {
        key: "edit",
        label: "Edit",
        icon: <EditOutlined />,
        resource: Resource.GROUP,
        action: Action.UPDATE,
        onClick: handleEdit,
      },
      {
        key: "remove",
        label: "Remove",
        icon: <DeleteOutlined />,
        danger: true,
        resource: Resource.GROUP,
        action: Action.DELETE,
        onClick: handleRemove,
      },
    ]
  }

  const { items: menuItems } = usePermissionedMenuItems({
    items: getActionMenuItems(),
  })

  if (menuItems.length === 0) {
    return <Text type="secondary">—</Text>
  }

  return (
    <>
      {contextHolder}
      <Dropdown menu={{ items: menuItems }} trigger={["click"]}>
        <Button
          type={type}
          icon={iconOnly ? <MoreOutlined /> : undefined}
          size={size}
          data-testid={`group-member-actions-${member.uuid}`}
        >
          {!iconOnly && "Actions"}
        </Button>
      </Dropdown>
    </>
  )
}
